import { render, staticRenderFns } from "./transferitem.vue?vue&type=template&id=3ac3d20e&scoped=true"
import script from "./transferitem.vue?vue&type=script&lang=js"
export * from "./transferitem.vue?vue&type=script&lang=js"
import style0 from "./transferitem.vue?vue&type=style&index=0&id=3ac3d20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac3d20e",
  null
  
)

export default component.exports